export const auth = {
  login: "accounts/login/store/",
  logout: "accounts/logout/",
  register: "accounts/register/store/",
  otp: "accounts/otp/store/",
  resend_otp: "accounts/resend/otp/store/",
  forget_password: "accounts/forget/password/store/",
  confrim_forget_password: "accounts/confirm/forget/password/store/",
  get_store_info: "accounts/store/own/",
  update_store_info: "accounts/store/own/",
};
